import React, { useState, useEffect } from "react";
import { FaSearch, FaFilter, FaCheck, FaTimes, FaClock } from "react-icons/fa";
import Pagination from "../components/Pagination/Pagination";
import { mission, userEvent } from "../controller";
import Loading from "../components/Loading";
import { use } from "react";

const admins = [
  "LaiVTP@hunghau.vn",
  "NhiNNT@hunghau.vn",
  "uyenltt@hunghau.vn",
  "aihx@hunghau.vn",
  "thienlh@hexagon.xyz",
  "Xuannhh@vhu.edu.vn",
  "xuannhh@vhu.edu.vn",
  "thipv@hexagon.xyz",
  "truongnl@hunghau.vn",
  "DuyNK@hunghau.vn",
  "QuanNH2@hunghau.vn",
  "DungNTV@hunghau.vn",
  "LinhLN@hunghau.vn",
  "huyenptm@hunghau.vn",
  "NhiNNT@hunghau.vn",
  "aihx@hunghau.vn"
];

function AdminPage() {
  useEffect(() => {
    // Check if user is admin
    // const checkIsAdmin = async () => {
    //   const res = await userEvent.checkIsAdmin({
    //     mail: sessionStorage.getItem("mail"),
    //   });
    //   if (!res || !res.isAdmin) {
    //   }
    // };
    if (admins.includes(sessionStorage.getItem("mail"))) {
      return;
    }
    // If not admin, redirect to home
    window.location.href = "/"; // Redirect to home if not admin
    // checkIsAdmin();
  }, []);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    team: "",
    mission: "",
    search: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });
  const [sortConfig, setSortConfig] = useState({
    field: "updatedAt",
    order: "DESC",
  });

  // Static data for filter options
  const statusOptions = [
    { value: "", label: "Tất cả trạng thái" },
    { value: "pending", label: "Chờ duyệt" },
    { value: "approved", label: "Đã duyệt" },
    { value: "rejected", label: "Từ chối" },
  ];

  const teamOptions = [
    { value: "", label: "Tất cả đội" },
    { value: "Đội Harmony", label: "Đội Harmony" },
    { value: "Đội Heart", label: "Đội Heart" },
    { value: "Đội House", label: "Đội House" },
    { value: "Đội Aurora", label: "Đội Aurora" },
  ];

  const missionOptions = [
    { value: "", label: "Tất cả nhiệm vụ" },
    { value: "1", label: "Nhiệm vụ 1" },
    { value: "2", label: "Nhiệm vụ 2" },
    { value: "3", label: "Nhiệm vụ 3" },
    { value: "4", label: "Nhiệm vụ 4" },
  ];

  // Fetch submissions
  const fetchSubmissions = async () => {
    try {
      setLoading(true);
      const response = await mission.getSubmission({
        page: pagination.page,
        limit: pagination.limit,
        search: filters.search,
        sortField: sortConfig.field,
        sortOrder: sortConfig.order,
        status: filters.status || undefined,
        team: filters.team || undefined,
        mission: filters.mission || undefined,
      });

      if (response) {
        setSubmissions(response.submissions || response);
        // If API returns pagination info, update it
        const totalPages = response.totalCount
          ? Math.ceil(response.totalCount / pagination.limit)
          : 0;
        setPagination((prev) => ({
          ...prev,
          total: response.totalCount,
          totalPages,
        }));
      }
    } catch (error) {
      console.error("Error fetching submissions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Update submission status
  const updateSubmissionStatus = async (id, newStatus) => {
    try {
      const response = await mission.updateSubmissionStatus({
        id,
        status: newStatus,
      });
      if (response.message === "Submission status updated successfully") {
        // Refresh submissions
        fetchSubmissions();
      } else {
        alert("Cập nhật trạng thái không thành công");
      }
    } catch (error) {
      console.error("Error updating submission status:", error);
      alert("Có lỗi xảy ra khi cập nhật trạng thái");
    }
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  };

  // Handle sort
  const handleSort = (field) => {
    setSortConfig((prev) => ({
      field,
      order: prev.field === field && prev.order === "DESC" ? "ASC" : "DESC",
    }));
    setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page
  };

  // Handle pagination
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  // Helper functions
  const getStatusText = (status) => {
    switch (status) {
      case "approved":
        return "Đã duyệt";
      case "pending":
        return "Chờ duyệt";
      case "rejected":
        return "Từ chối";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "text-green-600 bg-green-100";
      case "pending":
        return "text-yellow-600 bg-yellow-100";
      case "rejected":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "approved":
        return <FaCheck className="text-green-600" />;
      case "pending":
        return <FaClock className="text-yellow-600" />;
      case "rejected":
        return <FaTimes className="text-red-600" />;
      default:
        return null;
    }
  };

  const getMissionName = (mission) => {
    return `Nhiệm vụ ${mission}`;
  };

  const getPoints = (mission, status) => {
    if (status !== "approved") return 0;
    const pointsMap = { 1: 20, 2: 10, 3: 5, 4: 1 };
    return pointsMap[mission] || 0;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return (
      date.toLocaleDateString("vi-VN") + " " + date.toLocaleTimeString("vi-VN")
    );
  };

  // Effects
  useEffect(() => {
    fetchSubmissions();
  }, [pagination.page, pagination.limit, filters, sortConfig]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0253e1] to-[#25c8ff] p-6 font-montserrat">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white/20 rounded-3xl px-6 py-8 mb-8 shadow-lg">
          <h1 className="text-4xl font-bold text-center text-white mb-2">
            QUẢN LÝ BÀI DỰ THI
          </h1>
          <p className="text-center text-white/80">
            Duyệt và quản lý các bài nộp từ người dùng
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white/20 rounded-3xl px-6 py-6 mb-8 shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            <FaFilter className="text-white text-xl" />
            <h2 className="text-xl font-bold text-white">BỘ LỌC</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            {/* Status Filter */}
            <div>
              <label className="block text-white font-medium mb-2">
                Trạng thái
              </label>
              <select
                value={filters.status}
                onChange={(e) => handleFilterChange("status", e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Team Filter */}
            <div>
              <label className="block text-white font-medium mb-2">Đội</label>
              <select
                value={filters.team}
                onChange={(e) => handleFilterChange("team", e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {teamOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Mission Filter */}
            <div>
              <label className="block text-white font-medium mb-2">
                Nhiệm vụ
              </label>
              <select
                value={filters.mission}
                onChange={(e) => handleFilterChange("mission", e.target.value)}
                className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {missionOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Search */}
            <div>
              <label className="block text-white font-medium mb-2">
                Tìm kiếm link
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={filters.search}
                  onChange={(e) => handleFilterChange("search", e.target.value)}
                  placeholder="Nhập link để tìm kiếm..."
                  className="w-full px-3 py-2 pl-10 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          </div>
        </div>

        {/* Submissions Table */}
        <div className="bg-white/20 rounded-3xl px-6 py-6 shadow-lg">
          {loading ? (
            <Loading></Loading>
          ) : submissions.length > 0 ? (
            <>
              <div className="overflow-x-auto">
                <table className="w-full bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gradient-to-r from-[#0253e1] to-[#25c8ff]">
                    <tr>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold ">
                        Nhiệm vụ
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Đội
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Người chơi
                      </th>
                      <th className="px-4 py-3 text-left text-white font-bold">
                        Link
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Trạng thái
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Điểm
                      </th>
                      <th
                        className="px-4 py-3 text-center text-white font-bold cursor-pointer hover:bg-white/10"
                        onClick={() => handleSort("updatedAt")}
                      >
                        Cập nhật{" "}
                        {sortConfig.field === "updatedAt" &&
                          (sortConfig.order === "DESC" ? "↓" : "↑")}
                      </th>
                      <th className="px-4 py-3 text-center text-white font-bold">
                        Thao tác
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {submissions.map((submission, index) => (
                      <tr
                        key={submission.id}
                        className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                      >
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          #{submission.id}
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {getMissionName(submission.mission)}
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {submission.team}
                        </td>
                        <td className="px-4 py-3 text-gray-800 font-medium">
                          {submission.userEventMail || "Chưa có người chơi"}
                        </td>
                        <td className="px-4 py-3">
                          <a
                            href={submission.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 underline break-all text-sm max-w-xs block truncate"
                            title={submission.link}
                          >
                            {submission.link}
                          </a>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex items-center justify-center gap-2">
                            {getStatusIcon(submission.status)}
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                submission.status
                              )}`}
                            >
                              {getStatusText(submission.status)}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center font-bold text-gray-800">
                          {getPoints(submission.mission, submission.status)}
                        </td>
                        <td className="px-4 py-3 text-center text-sm text-gray-600">
                          {formatDate(submission.updatedAt)}
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex gap-2 justify-center">
                            {submission.status !== "approved" && (
                              <button
                                onClick={() =>
                                  updateSubmissionStatus(
                                    submission.id,
                                    "approved"
                                  )
                                }
                                className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition"
                                title="Duyệt"
                              >
                                <FaCheck />
                              </button>
                            )}
                            {submission.status !== "rejected" && (
                              <button
                                onClick={() =>
                                  updateSubmissionStatus(
                                    submission.id,
                                    "rejected"
                                  )
                                }
                                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition"
                                title="Từ chối"
                              >
                                <FaTimes />
                              </button>
                            )}
                            {/* {submission.status !== 'pending' && (
                              <button
                                onClick={() => updateSubmissionStatus(submission.id, 'pending')}
                                className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm transition"
                                title="Chờ duyệt"
                              >
                                <FaClock />
                              </button>
                            )} */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="mt-6 flex justify-center">
                <Pagination
                  currentPage={pagination.page}
                  totalPages={pagination.totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </>
          ) : (
            <div className="text-center text-white text-lg py-8">
              Không có submission nào
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
